import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { cookie } from 'toolbox/cookie';
import { debounce } from 'toolbox/debounce';

/**
 * File that initialize properly Live Agent
 * @class
 * @classdesc This is a description of the LiveAgent class. (must be edited)
 * @extends Component
 */
export default class LiveAgent extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            dataLayerContainer: 'dataLayer', // supported: dataLayer, superDataLayer
            data: {
                nbChasitorMessage: 0,
                nbAgentMessage: 0,
            },
            initUrl: '',
            country: '',
            brand: '',
            language: '',
            consentDependencyEnable: false,
            consentGroupID: '',
        }, options));
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        if (this.options.initUrl && this.options.country && this.options.brand && this.options.language) {
            debounce(this.initLiveChat.bind(this), 1000)();
        }
    }

    /**
     * @description Initializes LiveChat
     */
    initLiveChat() {
        if (this.options.consentDependencyEnable && this.options.consentGroupID) {
            window.addEventListener('consentManagementComponentLoaded', function transferScriptToOptanon() {
                if (window.Optanon) {
                    window.Optanon.InsertScript(this.options.initUrl, 'body', null, null, this.options.consentGroupID);
                }
            });
        } else if (window.CCLiveChat) {
            window.CCLiveChat.init(
                this.options.initUrl,
                this.options.country,
                this.options.brand,
                this.options.language,
                this.afterLoad(),
                this.getLiveAgentEvent(),
            );
            this.getData();
        }
    }

    /**
     * @description Defines object send to LiveChat to bind events
     * @returns { Object } Object of functions
     */
    getLiveAgentEvent() {
        return {
            onChatEstablished: this.startChat.bind(this),
            onChasitorMessage: this.onChasitorMessage.bind(this),
            onAgentMessage: this.onAgentMessage.bind(this),
            onChatEndedByChasitor: this.endChat.bind(this),
            onChatEndedByAgent: this.endChat.bind(this),
        };
    }

    /**
     * @description Empty function used on live chat side
     */
    afterLoad() {
    }

    /**
     * @description Define chat start time and push the start chat event
     */
    startChat() {
        this.options.data.sessionStartDate = new Date();
        this.pushEvent('start');
        this.setData();
    }

    /**
     * @description Increase nbAgentMessage when an agent message is received
     */
    onAgentMessage() {
        this.options.data.nbAgentMessage += 1;
        this.setData();
    }

    /**
     * @description Increase nbChasitorMessage when an chasitor message is received
     */
    onChasitorMessage() {
        this.options.data.nbChasitorMessage += 1;
        this.setData();
    }

    /**
     * @description Set the liveAgentSessionCookie
     */
    setData() {
        cookie.setCookie('liveAgentSessionCookie', JSON.stringify(this.options.data));
    }

    /**
     * @description Get the liveAgentSessionCookie
     */
    getData() {
        const liveAgentSessionCookie = cookie.getCookie('liveAgentSessionCookie');
        if (liveAgentSessionCookie && liveAgentSessionCookie !== 'undefined') {
            this.options.data = JSON.parse(liveAgentSessionCookie);
        }
    }

    /**
     * @description Push the total duration of the conversation in the dataLayer
     */
    endChat() {
        if (this.options.data.nbChasitorMessage && this.options.data.nbAgentMessage) {
            const endDate = new Date();
            const durationMinute = Math.ceil((endDate - new Date(this.options.data.sessionStartDate)) / 1000) / 60;

            this.pushEvent(`stop::${durationMinute}`);
        }
    }

    /**
     * @description Retrieve the current dataLayer and push data in it
     * @param {String} label eventLabel value
     */
    pushEvent(label) {
        window[this.options.dataLayerContainer] = window[this.options.dataLayerContainer] || [];
        const event = {
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'main menu navigation',
            eventAction: 'select::live chat',
            eventLabel: label,
        };
        window[this.options.dataLayerContainer].push(event);
    }
}
